<div [formGroup]="freightQuotationForm" *ngIf="estimations">
  <div class="gray-bg-rounded">
    <div
      formArrayName="freightEstimationSections"
      *ngIf="freightEstimationSections.length > 0"
      class="freightchangesdetail-scroll pb-3">
      <div
        class="col-lg-12"
        *ngFor="
          let estimation of freightEstimationSections.controls;
          let i = index
        ">
        <div
          [formGroup]="getFormGroup(i)"
          *ngIf="hasSomeEstimations(estimation)">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h3 class="mb-0">Select the rates you would like on the quote</h3>
              <h6 class="mb-0">{{ estimation.value.shipmentDescription }}</h6>
            </div>
            <div class="mr-3 align-items-center d-flex gap-2">
              <p-checkBox
                name="estimation.value.sectionId"
                [inputId]="'all-' + i"
                [value]="0"
                [binary]="true"
                (onChange)="
                  onSelectQuoteOption(getFormGroup(i), i, $event, 'All')
                " />
              <label class="mt-1">All</label>
            </div>
          </div>

          <div>
            <div class="col-lg-12 freight-listing">
              <div class="d-flex">
                <div class="col-lg-7"></div>
                <div class="col-lg-4">
                  <div class="d-flex justify-content-start mt-2">
                    <div style="width: 100px"><p class="m-0">Retail</p></div>
                    <div style="width: 100px">
                      <p class="m-0">Discount</p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-1"></div>
              </div>
            </div>
            <div class="col-lg-12 freight-listing">
              <div
                class="p-3 freight-listing-box mb-2"
                *ngFor="
                  let pricing of groupByEstimatedArrivalDate(
                    estimation.value.freightEstimationSectionPricing
                  );
                  trackBy: trackById
                ">
                <div class="d-flex" *ngIf="pricing.estimatedDate">
                  <div class="col-lg-3">
                    <p>ARRIVES ON</p>
                    <label>{{
                      pricing.estimatedDate | date: "MM-dd-yyyy"
                    }}</label>
                  </div>

                  <div
                    class="fre-box col-lg-9"
                    *ngIf="pricing.freightEstimationSectionPricings.length > 0">
                    <div
                      class="globalborder-btm-header pt-2 pb-2 box-lst"
                      *ngFor="
                        let price of pricing.freightEstimationSectionPricings;
                        let pi = index
                      ">
                      <div class="d-flex justify-content-between gap-2">
                        <div class="col-lg-5">
                          <div class="delcol">
                            <p class="mb-1">
                              {{ price.shipmentMethodDescription }}
                            </p>
                            <label>
                              {{ price.estimatedDeliveryTime }}
                            </label>
                          </div>
                        </div>

                        <div class="col freight-btn">
                          <!-- <p-button
                            label="{{
                              priceFormat(price.totalCharges)
                            }}"></p-button> -->

                          <p-button
                            label="{{ priceFormat(price.totalCharges) }}" />
                        </div>

                        <div class="col freight-btn">
                          <!-- <p-button
                            severity="info"
                            (onClick)="showOrHidePricingModal(price)"
                            label="${{
                              priceFormat(price.discountedTotalCharges)
                            }}"></p-button> -->

                          <p-button
                            (onClick)="showOrHidePricingModal(price)"
                            label="${{
                              priceFormat(price.discountedTotalCharges)
                            }}"
                            severity="info" />
                        </div>

                        <div>
                          <p-checkbox
                            name="pi"
                            [binary]="true"
                            [ngModel]="
                              getFormGroup(i).value
                                .freightEstimationSectionPricing[
                                price.priceIndex ?? 0
                              ]?.isSelected
                            "
                            [ngModelOptions]="{ standalone: true }"
                            (onChange)="
                              onSelectQuoteOption(
                                getFormGroup(i),
                                price.priceIndex ?? 0,
                                $event
                              )
                            ">
                          </p-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="hasValidEstimations"
        class="freight-btn02 d-flex justify-content-between mt-4">
        <div class="d-flex gap-2 align-items-center">
          <label class="package-label mt-1" for="package-detail">
            Package Details
          </label>
          <p-checkBox
            name="package-detail"
            inputId="package-detail"
            [value]="freightQuotationForm.value.isPackageDetail"
            [binary]="true"
            (onChange)="onPackageDetailSelected()" />
        </div>
        <div class="freight-btn02">
          <p-button
            label="Generate Quote"
            [disabled]="!isQuoteSelected"
            (onClick)="generateQuotation()"></p-button>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!estimations">
  <div class="col-lg-12 mt-4">
    <div class="gray-bg-rounded">
      <div class="freightchangesdetail-scroll">
        <h3>Accuracy of Estimates -</h3>
        <p>
          This tool is intended for internal use only and provides estimates
          based on the information entered. The accuracy of the estimate depends
          on the accuracy of the data provided. We recommend including a buffer
          of 10% when sharing quotes with clients to account for potential
          variances.
        </p>

        <h3>Scope of Estimate -</h3>
        <p>
          The estimate generated covers transit costs only. It does not include
          duties, taxes, or other potential charges. For assistance with
          estimating duties and taxes, please contact
          <a href="mailto:trade@nadel.com">trade&#64;nadel.com</a>
        </p>

        <h3>Weight Limit Consideration -</h3>
        <p>
          If your total shipment weight exceeds 250 lbs., please contact
          Freight&#64;nadel.com for an air freight quote, as this tool is
          optimized for standard shipments under this limit
        </p>
      </div>
    </div>
  </div>
</div>
<p-dialog
  [position]="'center'"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showPricingDetailDialog"
  [closable]="true"
  [style]="{
    width: '50%',
    height: 'auto',
    'min-height': '180px',
    'border-radius': '10px',
    overflow: 'visible',
  }"
  appendTo="body">
  <ng-template pTemplate="header">
    <div class="col-lg-10 gap-2 d-flex">
      <p>Package Price Detail</p>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <p-table
      [value]="selectedPackageModal ?? []"
      #dt
      stripedRows
      [rowHover]="true"
      responsiveLayout="scroll"
      styleClass="table-listing">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th>Description</th>
          <th>Value</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-FreightChargesDetail
        let-rowIndex="rowIndex">
        <tr>
          <td>{{ FreightChargesDetail.pricingDetailDescription }}</td>
          <td>
            {{ FreightChargesDetail.pricingDetailAmount | number: "1.2-2" }}
          </td>
          <td
            [ngClass]="{
              coloured: ['KG', 'LB', 'LBS'].includes(
                FreightChargesDetail.pricingCurrencyCode
              ),
            }">
            {{ FreightChargesDetail.pricingCurrencyCode }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-dialog>

<p-dialog
  header="Quote Summary"
  [(visible)]="pdfViewerPage"
  position="center"
  [modal]="true"
  [style]="{ width: '100vw', height: '100vw' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  (onHide)="closeModalPdfViewerPage()">
  <p class="panelHeading mt-5"></p>
  <div class="panelBody">
    <ngx-extended-pdf-viewer
      [base64Src]="base64Pdf"
      [textLayer]="true"
      [showHandToolButton]="true"
      [showPresentationModeButton]="true"
      [filenameForDownload]="fileNameToDownload"></ngx-extended-pdf-viewer>
  </div>
</p-dialog>
